<template>
  <model-table
    :collection="paymentConnectorTransactionNumbers"
    show-add
    add-label="Batch"
    :show-filter="false"
    :columns="[
      { field: 'id' },
      { field: 'transactionType' },
      { field: 'startId' },
      { field: 'endId' },
      { field: 'startDate', name: 'Effective From', component: 'date' },
      { field: 'endDate', name: 'Effective To', component: 'date' }
    ]"
  >
    <template
      #header-controls
    >
      <q-btn-group style="margin-left: auto;">
        <q-btn
          v-for="option in [
            { label: 'All', value: 'all' },
            { label: 'Valid', value: 'valid' },
            { label: 'Past', value: 'past' },
            { label: 'Future', value: 'future' }
          ]"
          :key="option.value"
          :label="option.label"
          :color="option.value === currentFilter ? 'primary' : 'grey'"
          @click="() => currentFilter = option.value"
        />
      </q-btn-group>
    </template>
    <payment-connector-transaction-number-form :payment-connector-configuration="paymentConnectorConfiguration" />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import PaymentConnectorTransactionNumberForm from 'src/modules/admin/payment-connector/PaymentConnectorTransactionNumberForm'

export default {
  name: 'PaymentConnectorTransactionNumberTable',
  components: {
    ModelTable,
    PaymentConnectorTransactionNumberForm
  },
  props: {
    paymentConnectorConfigurationId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      currentFilter: 'valid'
    }
  },
  models: {
    paymentConnectorTransactionNumbers: {
      variables () {
        return {
          paymentConnectorConfigurationId: this.paymentConnectorConfigurationId,
          filter: this.currentFilter
        }
      }
    },
    paymentConnectorConfiguration: {
      variables () {
        return {
          id: this.paymentConnectorConfigurationId
        }
      },
      immediate: true
    }
  }
}
</script>
